import { render, staticRenderFns } from "./NuevoMovimientoBasico.vue?vue&type=template&id=7fd89e1c&scoped=true&"
import script from "./NuevoMovimientoBasico.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimientoBasico.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimientoBasico.vue?vue&type=style&index=0&id=7fd89e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd89e1c",
  null
  
)

export default component.exports